import DropdownLayoutV2 from "../components/DropdownLayoutV2";
import GoogleUserConnection from "../rules/GoogleUserConnection";
import React from "react";
import AzureUserConnection from "../rules/AzureUserConnection";
import { getBaseUrl } from "../api/api";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";

export const systemLabels = (appId) => {
  if (appId == "google") {
    return [
      { id: "INBOX", name: "Inbox", color: "text-blue-600" },
      { id: "SENT", name: "Sent", color: "text-gray-600" },
      { id: "UNREAD", name: "Unread", color: "text-gray-600" },
      {
        id: "CATEGORY_PROMOTIONS",
        name: "Promotions",
        color: "text-red-600",
      },
      { id: "CATEGORY_UPDATES", name: "Updates", color: "text-blue-600" },
      { id: "CATEGORY_SOCIAL", name: "Socials", color: "text-green-600" },
      { id: "SPAM", name: "Spam", color: "text-gray-600" },
    ];
  }
  return [
    { id: "FOCUSED", name: "Focused", color: "text-blue-600" },
    { id: "NORMAL", name: "Normal", color: "text-blue-600" },
    { id: "SENT", name: "Sent", color: "text-gray-600" },
    { id: "UNREAD", name: "Unread", color: "text-gray-600" },
  ];
};

const MessageListToolbar = ({
  handleSelectApp,
  appId,
  onPrev,
  onNext,
  onToday,
  isToday,
  dateRangeDisplay,
}) => {
  const renderCurrentInboxAppIcon = () => {
    if (appId == "google") {
      return (
        <img
          alt={""}
          className={"w-6 rounded-sm"}
          src={`${getBaseUrl()}/static/images/gmail.png`}
        />
      );
    }
    return (
      <img
        alt={""}
        className={"w-6 rounded-sm"}
        src={`${getBaseUrl()}/static/images/outlook.png`}
      />
    );
  };

  const renderCurrentConnection = () => {
    if (appId == "google") {
      return <GoogleUserConnection />;
    }
    return <AzureUserConnection />;
  };

  const renderOtherInboxApp = () => {
    if (appId == "google") {
      return (
        <div
          className={"w-full flex items-center space-x-2 px-2"}
          onClick={() => {
            handleSelectApp("azure");
          }}
        >
          <img className={"w-6 rounded-sm"} src={`${getBaseUrl()}/static/images/outlook.png`} />
          <div>{"Outlook"}</div>
        </div>
      );
    }
    return (
      <div
        className={"w-full flex items-center space-x-2 px-2"}
        onClick={() => {
          handleSelectApp("google");
        }}
      >
        <img className={"w-6 rounded-sm"} src={`${getBaseUrl()}/static/images/gmail.png`} />
        <div>{"Gmail"}</div>
      </div>
    );
  };

  return (
    <div className={"flex w-full p-4 border-b border-gray-100 relative"}>
      <div className="flex items-center space-x-1">
        {renderCurrentInboxAppIcon()}
        <DropdownLayoutV2 activator={renderCurrentConnection()}>
          <div className={"p-2 space-y-1"}>
            <div
              className={
                "flex space-x-1 items-center justify-center py-2 space-x-2 hover:bg-blue-100 cursor-pointer rounded-sm"
              }
            >
              {renderOtherInboxApp()}
            </div>
          </div>
        </DropdownLayoutV2>
      </div>

      <div className={"flex absolute right-4 text-sm space-x-2 items-center"}>
        <div className="font-medium text-gray-600">{dateRangeDisplay}</div>
        <button
          onClick={onPrev}
          className="p-2 rounded-lg bg-white border border-white shadow-sm hover:bg-gray-50 transition-colors"
          aria-label="Previous"
        >
          <ChevronLeftIcon className="w-5 h-5 text-gray-600" />
        </button>
        <button
          onClick={onToday}
          className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors ${
            isToday
              ? "text-white bg-blue-500 border-blue-500 hover:bg-blue-600"
              : "text-gray-700 bg-white border-white hover:bg-gray-50"
          }`}
        >
          Today
        </button>
        <button
          onClick={onNext}
          disabled={isToday}
          className="p-2 rounded-lg bg-white border border-white shadow-sm hover:bg-gray-50 transition-colors"
          aria-label="Next"
        >
          <ChevronRightIcon className="w-5 h-5 text-gray-600" />
        </button>
      </div>
    </div>
  );
};

export default MessageListToolbar;
